import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-export.svg'


const _hoisted_1 = { class: "page-we" }
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "export-icon",
  src: _imports_0
}
const _hoisted_6 = {
  key: 1,
  class: "export-btn-label"
}
const _hoisted_7 = {
  key: 2,
  class: "export-btn-label"
}
const _hoisted_8 = { class: "project-summary-card" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "card-title-wrapper" }
const _hoisted_11 = { class: "card-title-content" }
const _hoisted_12 = { class: "total-sales-display" }
const _hoisted_13 = { class: "total-sales-value" }
const _hoisted_14 = { class: "card-content" }
const _hoisted_15 = { class: "stages-grid" }
const _hoisted_16 = { class: "stage-header" }
const _hoisted_17 = { class: "stage-name" }
const _hoisted_18 = { class: "stage-completion" }
const _hoisted_19 = { class: "completion-percentage" }
const _hoisted_20 = { class: "progress-bar-container" }
const _hoisted_21 = { class: "progress-bar" }
const _hoisted_22 = { class: "stage-stats" }
const _hoisted_23 = { class: "stat-value" }
const _hoisted_24 = { class: "stat-value" }
const _hoisted_25 = { class: "stat-value" }
const _hoisted_26 = { class: "stat-value" }
const _hoisted_27 = {
  key: 0,
  class: "project-totals"
}
const _hoisted_28 = { class: "total-item" }
const _hoisted_29 = { class: "total-value" }
const _hoisted_30 = { class: "total-item" }
const _hoisted_31 = { class: "total-value" }
const _hoisted_32 = { class: "total-item" }
const _hoisted_33 = { class: "total-value" }
const _hoisted_34 = { class: "total-item" }
const _hoisted_35 = { class: "total-value" }
const _hoisted_36 = { class: "sales-report-section" }
const _hoisted_37 = { class: "sales-report-header-card" }
const _hoisted_38 = { class: "report-header" }
const _hoisted_39 = { class: "report-header-left" }
const _hoisted_40 = { class: "dropdown-button" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "status-cards-grid"
}
const _hoisted_43 = { class: "status-card available" }
const _hoisted_44 = { class: "status-card-header" }
const _hoisted_45 = { class: "status-card-content" }
const _hoisted_46 = { class: "status-count" }
const _hoisted_47 = { class: "status-value" }
const _hoisted_48 = { class: "status-card on-hold" }
const _hoisted_49 = { class: "status-card-header" }
const _hoisted_50 = { class: "status-card-content" }
const _hoisted_51 = { class: "status-count" }
const _hoisted_52 = { class: "status-value" }
const _hoisted_53 = { class: "active-contracts-group" }
const _hoisted_54 = { class: "active-contracts-cards" }
const _hoisted_55 = { class: "status-card under-contract" }
const _hoisted_56 = { class: "status-card-header" }
const _hoisted_57 = { class: "status-card-content" }
const _hoisted_58 = { class: "status-count" }
const _hoisted_59 = { class: "status-value under-contract" }
const _hoisted_60 = { class: "status-card unconditional" }
const _hoisted_61 = { class: "status-card-header" }
const _hoisted_62 = { class: "status-card-content" }
const _hoisted_63 = { class: "status-count" }
const _hoisted_64 = { class: "status-value unconditional" }
const _hoisted_65 = { class: "status-card settled" }
const _hoisted_66 = { class: "status-card-header" }
const _hoisted_67 = { class: "status-card-content" }
const _hoisted_68 = { class: "status-count" }
const _hoisted_69 = { class: "status-value" }
const _hoisted_70 = {
  key: 1,
  class: "detailed-tables"
}
const _hoisted_71 = { class: "lots-table-card" }
const _hoisted_72 = { class: "table-card-header" }
const _hoisted_73 = { class: "table-card-title" }
const _hoisted_74 = { class: "table-card-meta" }
const _hoisted_75 = { class: "table-card-description" }
const _hoisted_76 = { class: "table-content" }
const _hoisted_77 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_78 = { class: "empty-state-icon" }
const _hoisted_79 = { class: "empty-state-content" }
const _hoisted_80 = { class: "empty-state-description" }
const _hoisted_81 = {
  key: 1,
  class: "lots-table"
}
const _hoisted_82 = { class: "lot-number" }
const _hoisted_83 = { class: "lot-price" }
const _hoisted_84 = { class: "lot-buyer" }
const _hoisted_85 = { class: "lot-days" }
const _hoisted_86 = { class: "badge badge-outline" }
const _hoisted_87 = {
  key: 2,
  class: "detailed-tables"
}
const _hoisted_88 = { class: "lots-table-card" }
const _hoisted_89 = { class: "table-card-header" }
const _hoisted_90 = { class: "table-card-title" }
const _hoisted_91 = { class: "table-card-meta" }
const _hoisted_92 = { class: "table-card-description" }
const _hoisted_93 = { class: "table-content" }
const _hoisted_94 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_95 = { class: "empty-state-icon" }
const _hoisted_96 = { class: "empty-state-content" }
const _hoisted_97 = { class: "empty-state-description" }
const _hoisted_98 = {
  key: 1,
  class: "lots-table"
}
const _hoisted_99 = { class: "lot-number" }
const _hoisted_100 = { class: "lot-price" }
const _hoisted_101 = { class: "lot-buyer" }
const _hoisted_102 = { class: "status" }
const _hoisted_103 = { class: "contract-date" }
const _hoisted_104 = { class: "deposit" }
const _hoisted_105 = { class: "conditions" }
const _hoisted_106 = { class: "finance-due" }
const _hoisted_107 = { class: "activity-card" }
const _hoisted_108 = { class: "activity-card-header" }
const _hoisted_109 = { class: "activity-card-title" }
const _hoisted_110 = { class: "activity-card-controls" }
const _hoisted_111 = { class: "dropdown-button" }
const _hoisted_112 = ["onClick"]
const _hoisted_113 = {
  key: 0,
  class: "custom-date-inputs"
}
const _hoisted_114 = { class: "activity-card-description" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { class: "activity-grid" }
const _hoisted_117 = { class: "activity-item put-on-hold" }
const _hoisted_118 = { class: "activity-item-header" }
const _hoisted_119 = { class: "activity-item-content" }
const _hoisted_120 = { class: "activity-count" }
const _hoisted_121 = {
  key: 0,
  class: "activity-note"
}
const _hoisted_122 = { class: "activity-item contracts-signed" }
const _hoisted_123 = { class: "activity-item-header" }
const _hoisted_124 = { class: "activity-item-content" }
const _hoisted_125 = { class: "activity-count" }
const _hoisted_126 = { class: "activity-item cancellations" }
const _hoisted_127 = { class: "activity-item-content" }
const _hoisted_128 = { class: "activity-count" }
const _hoisted_129 = { class: "activity-label" }
const _hoisted_130 = {
  key: 0,
  class: "activity-note"
}
const _hoisted_131 = { class: "activity-item unconditional" }
const _hoisted_132 = { class: "activity-item-header" }
const _hoisted_133 = { class: "activity-item-content" }
const _hoisted_134 = { class: "activity-count" }
const _hoisted_135 = { class: "activity-item settlements" }
const _hoisted_136 = { class: "activity-item-header" }
const _hoisted_137 = { class: "activity-item-content" }
const _hoisted_138 = { class: "activity-count" }
const _hoisted_139 = {
  key: 0,
  class: "activity-note"
}
const _hoisted_140 = { class: "detailed-activity" }
const _hoisted_141 = {
  key: 0,
  class: "activity-breakdown-grid"
}
const _hoisted_142 = {
  key: 0,
  class: "breakdown-card holds-card"
}
const _hoisted_143 = { class: "breakdown-header" }
const _hoisted_144 = { class: "breakdown-content" }
const _hoisted_145 = { class: "breakdown-item-left" }
const _hoisted_146 = { class: "breakdown-lot" }
const _hoisted_147 = { class: "breakdown-date" }
const _hoisted_148 = { class: "breakdown-item-right" }
const _hoisted_149 = { class: "breakdown-price" }
const _hoisted_150 = { class: "breakdown-buyer" }
const _hoisted_151 = {
  key: 1,
  class: "breakdown-card contracts-card"
}
const _hoisted_152 = { class: "breakdown-header" }
const _hoisted_153 = { class: "breakdown-content" }
const _hoisted_154 = { class: "breakdown-item-left" }
const _hoisted_155 = { class: "breakdown-lot" }
const _hoisted_156 = { class: "breakdown-date" }
const _hoisted_157 = { class: "breakdown-item-right" }
const _hoisted_158 = { class: "breakdown-price" }
const _hoisted_159 = { class: "breakdown-buyer" }
const _hoisted_160 = {
  key: 2,
  class: "breakdown-card unconditional-card"
}
const _hoisted_161 = { class: "breakdown-header" }
const _hoisted_162 = { class: "breakdown-content" }
const _hoisted_163 = { class: "breakdown-item-left" }
const _hoisted_164 = { class: "breakdown-lot" }
const _hoisted_165 = { class: "breakdown-date" }
const _hoisted_166 = { class: "breakdown-item-right" }
const _hoisted_167 = { class: "breakdown-price" }
const _hoisted_168 = { class: "breakdown-buyer" }
const _hoisted_169 = {
  key: 3,
  class: "breakdown-card settlements-card"
}
const _hoisted_170 = { class: "breakdown-header" }
const _hoisted_171 = { class: "breakdown-content" }
const _hoisted_172 = { class: "breakdown-item-left" }
const _hoisted_173 = { class: "breakdown-lot" }
const _hoisted_174 = { class: "breakdown-date" }
const _hoisted_175 = { class: "breakdown-item-right" }
const _hoisted_176 = { class: "breakdown-price" }
const _hoisted_177 = { class: "breakdown-buyer" }
const _hoisted_178 = {
  key: 1,
  class: "no-activity-placeholder"
}
const _hoisted_179 = { class: "placeholder-content" }
const _hoisted_180 = { class: "placeholder-icon" }
const _hoisted_181 = {
  key: 0,
  class: "reports-spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "header-left" }, [
        _createElementVNode("h2", { class: "title-main" }, "Reports")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "export-btn",
          onClick: $setup.exportData,
          disabled: $setup.exportLoading || $setup.loading
        }, [
          (!$setup.exportLoading)
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true),
          ($setup.exportLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Exporting..."))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, "Export PDF"))
        ], 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode($setup["BarChart3"], { class: "title-icon" }),
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Project Sales Overview", -1))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.formatPrice($setup.sumAllStagesRevenue($setup.stages))), 1),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "total-sales-label" }, "Total Sales Value", -1))
          ])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "card-description" }, "Complete snapshot of all lots across the entire project as of today.", -1))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "stage-card",
              key: stage._id
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h3", _hoisted_17, "Stage " + _toDisplayString(stage.title), 1),
                _createElementVNode("div", _hoisted_18, [
                  ($setup.calculateStageCompletion(stage) === 100)
                    ? (_openBlock(), _createBlock($setup["CheckCircle"], {
                        key: 0,
                        class: "completion-icon",
                        color: "#10b981"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_19, _toDisplayString($setup.calculateStageCompletion(stage)) + "% Sold", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", {
                    class: "progress-fill",
                    style: _normalizeStyle({ width: $setup.calculateStageCompletion(stage) + '%' })
                  }, null, 4)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", {
                  class: _normalizeClass(["stat-item total", { 'stat-disabled': stage.counts.total === 0 }])
                }, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(stage.counts.total), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "stat-label" }, "Total", -1))
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["stat-item available", { 'stat-disabled': stage.counts.available === 0 }])
                }, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(stage.counts.available), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "stat-label" }, "Available", -1))
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["stat-item contract", { 'stat-disabled': stage.counts.underContract + stage.counts.unconditional === 0 }])
                }, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(stage.counts.underContract + stage.counts.unconditional), 1),
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "stat-label" }, "Contract", -1))
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["stat-item sold", { 'stat-disabled': stage.counts.settled === 0 }])
                }, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(stage.counts.settled), 1),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "stat-label" }, "Sold", -1))
                ], 2)
              ])
            ]))
          }), 128))
        ]),
        ($setup.totalLotsByStatus)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString($setup.totalLotsByStatus.total), 1),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "total-label" }, "Total Lots", -1))
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, _toDisplayString($setup.totalLotsByStatus.available), 1),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "total-label" }, "Available", -1))
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, _toDisplayString($setup.totalLotsByStatus.underContract + $setup.totalLotsByStatus.unconditional), 1),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "total-label" }, "Under Contract", -1))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, _toDisplayString($setup.totalLotsByStatus.settled), 1),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "total-label" }, "Sold (Settled)", -1))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "report-title" }, "Stage-by-Stage Breakdown", -1)),
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                _createElementVNode("button", _hoisted_40, _toDisplayString($setup.selectedStageId.label), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stageOptions, (stage) => {
                    return (_openBlock(), _createElementBlock("li", {
                      onClick: ($event: any) => ($setup.changeStage(stage)),
                      class: _normalizeClass({ 'dropdown__item-active': $setup.selectedStageId.value === stage.value })
                    }, _toDisplayString(stage.label), 11, _hoisted_41))
                  }), 256))
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "card-description" }, "Current lot status breakdown for each stage, including details of which specific lots are currently on hold or under contract. Filter by stage.", -1))
      ]),
      ($setup.totalLotsByStatus && $setup.totalRevenuePerStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "status-title" }, "Available", -1)),
                _createVNode($setup["Home"], {
                  class: "status-icon",
                  color: "#10b981"
                })
              ]),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, _toDisplayString($setup.selectedStageId.value === "all" ? $setup.totalLotsByStatus.available : $setup.selectedStage.counts.available), 1),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "status-label" }, "lots", -1)),
                _createElementVNode("div", _hoisted_47, _toDisplayString($setup.formatPrice($setup.selectedStageId.value === "all" ? $setup.totalRevenuePerStatus.available : $setup.selectedStage.revenue.available)), 1),
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "status-description" }, "total value", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "status-title" }, "On Hold", -1)),
                _createVNode($setup["Clock"], {
                  class: "status-icon",
                  color: "#0ea5e9"
                })
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, _toDisplayString($setup.selectedStageId.value === "all" ? $setup.totalLotsByStatus.hold : $setup.selectedStage.counts.hold), 1),
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "status-label" }, "lots", -1)),
                _createElementVNode("div", _hoisted_52, _toDisplayString($setup.formatPrice($setup.selectedStageId.value === "all" ? $setup.totalRevenuePerStatus.hold : $setup.selectedStage.revenue.hold)), 1),
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "status-description" }, "total value", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "active-contracts-header" }, "ACTIVE CONTRACTS", -1)),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "status-card-title" }, [
                      _createElementVNode("div", { class: "status-title" }, "Under Contract"),
                      _createElementVNode("div", { class: "status-subtitle" }, "(with conditions)")
                    ], -1)),
                    _createVNode($setup["FileText"], {
                      class: "status-icon",
                      color: "#2563eb"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, _toDisplayString($setup.selectedStageId.value === "all" ? $setup.classifiedActiveContractLots.all.underContract.quantity : $setup.classifiedActiveContractLots[$setup.selectedStage._id].underContract.quantity), 1),
                    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "status-label" }, "lots", -1)),
                    _createElementVNode("div", _hoisted_59, _toDisplayString($setup.formatPrice($setup.selectedStageId.value === "all" ? $setup.classifiedActiveContractLots.all.underContract.value : $setup.classifiedActiveContractLots[$setup.selectedStage._id].underContract.value)), 1),
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "status-description" }, "total value", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "status-card-title" }, [
                      _createElementVNode("div", { class: "status-title" }, "Unconditional"),
                      _createElementVNode("div", { class: "status-subtitle" }, "(no conditions)")
                    ], -1)),
                    _createVNode($setup["CheckCircle"], {
                      class: "status-icon",
                      color: "#8b5cf6"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, _toDisplayString($setup.selectedStageId.value === "all" ? $setup.classifiedActiveContractLots.all.unconditional.quantity : $setup.classifiedActiveContractLots[$setup.selectedStage._id].unconditional.quantity), 1),
                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "status-label" }, "lots", -1)),
                    _createElementVNode("div", _hoisted_64, _toDisplayString($setup.formatPrice($setup.selectedStageId.value === "all" ? $setup.classifiedActiveContractLots.all.unconditional.value : $setup.classifiedActiveContractLots[$setup.selectedStage._id].unconditional.value)), 1),
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "status-description" }, "total value", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "status-title" }, "Settled", -1)),
                _createVNode($setup["CheckCircle"], {
                  class: "status-icon",
                  color: "#ec4899"
                })
              ]),
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, _toDisplayString($setup.selectedStageId.value === "all" ? $setup.totalLotsByStatus.settled : $setup.selectedStage.counts.settled), 1),
                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "status-label" }, "lots", -1)),
                _createElementVNode("div", _hoisted_69, _toDisplayString($setup.formatPrice($setup.selectedStageId.value === "all" ? $setup.totalRevenuePerStatus.settled : $setup.selectedStage.revenue.settled)), 1),
                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "status-description" }, "total value", -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.totalRevenuePerStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createVNode($setup["Clock"], {
                    class: "table-icon",
                    color: "#0ea5e9"
                  }),
                  _createElementVNode("span", null, "Lots Currently on Hold (" + _toDisplayString($setup.getAllLotsForReports($setup.stages, [$setup.LotStatus.HOLD], $setup.selectedStageId.value).length) + ")", 1)
                ]),
                _createElementVNode("div", _hoisted_74, "As of " + _toDisplayString($setup.formatDate(new Date())), 1)
              ]),
              _createElementVNode("div", _hoisted_75, "Total value: " + _toDisplayString($setup.formatPrice($setup.selectedStageId.value === "all" ? $setup.totalRevenuePerStatus.hold : $setup.selectedStage.revenue.hold)), 1),
              _createElementVNode("div", _hoisted_76, [
                ($setup.getAllLotsForReports($setup.stages, [$setup.LotStatus.HOLD], $setup.selectedStageId.value).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createVNode($setup["Clock"], {
                          color: "#9ca3af",
                          size: "48"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _cache[33] || (_cache[33] = _createElementVNode("div", { class: "empty-state-title" }, "No Lots on Hold", -1)),
                        _createElementVNode("div", _hoisted_80, "There are currently no lots on hold in " + _toDisplayString($setup.selectedStageId.value === "all" ? "the project" : $setup.selectedStageId.label) + ".", 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("table", _hoisted_81, [
                      _cache[34] || (_cache[34] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Lot Number"),
                          _createElementVNode("th", null, "Price"),
                          _createElementVNode("th", null, "Buyer(s)"),
                          _createElementVNode("th", null, "Days on Hold")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAllLotsForReports($setup.stages, [$setup.LotStatus.HOLD], $setup.selectedStageId.value), (lot) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: lot._id
                          }, [
                            _createElementVNode("td", _hoisted_82, _toDisplayString(lot.title), 1),
                            _createElementVNode("td", _hoisted_83, _toDisplayString(lot.price && ["fixed", "from"].includes(lot.price.type?.toLowerCase()) && lot.price.value ? $setup.formatPrice(lot.price.value) : "--"), 1),
                            _createElementVNode("td", _hoisted_84, _toDisplayString($setup.getLotBuyers(lot.firstBuyer, lot.secondBuyer)), 1),
                            _createElementVNode("td", _hoisted_85, [
                              _createElementVNode("div", _hoisted_86, _toDisplayString($setup.calculateDaysOnHold(lot, $setup.lotsAuditLogs)) + " days", 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.totalRevenuePerStatus)
        ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _createVNode($setup["FileText"], {
                    class: "table-icon",
                    color: "#1d4ed8"
                  }),
                  _createElementVNode("span", null, "Currently Under Contract (" + _toDisplayString($setup.getAllLotsForReports($setup.stages, [$setup.LotStatus.UNDER_CONTRACT, $setup.LotStatus.UNCONDITIONAL], $setup.selectedStageId.value).length) + ")", 1)
                ]),
                _createElementVNode("div", _hoisted_91, "As of " + _toDisplayString($setup.formatDate(new Date())), 1)
              ]),
              _createElementVNode("div", _hoisted_92, "Total value: " + _toDisplayString($setup.formatPrice($setup.selectedStageId.value === "all" ? $setup.totalRevenuePerStatus.underContract + $setup.totalRevenuePerStatus.unconditional : $setup.selectedStage.revenue.underContract + $setup.selectedStage.revenue.unconditional)) + " • Includes contracts with and without conditions", 1),
              _createElementVNode("div", _hoisted_93, [
                ($setup.getAllLotsForReports($setup.stages, [$setup.LotStatus.UNDER_CONTRACT, $setup.LotStatus.UNCONDITIONAL], $setup.selectedStageId.value).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        _createVNode($setup["FileText"], {
                          color: "#9ca3af",
                          size: "48"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "empty-state-title" }, "No Active Contracts", -1)),
                        _createElementVNode("div", _hoisted_97, "There are currently no lots under contract in " + _toDisplayString($setup.selectedStageId.value === "all" ? "the project" : $setup.selectedStageId.label) + ".", 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("table", _hoisted_98, [
                      _cache[36] || (_cache[36] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Lot Number"),
                          _createElementVNode("th", null, "Price"),
                          _createElementVNode("th", null, "Buyer(s)"),
                          _createElementVNode("th", null, "Status"),
                          _createElementVNode("th", null, "Contract Signed"),
                          _createElementVNode("th", null, "Deposit Held"),
                          _createElementVNode("th", null, "Conditions"),
                          _createElementVNode("th", null, "Finance Due")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getAllLotsForReports($setup.stages, [$setup.LotStatus.UNDER_CONTRACT, $setup.LotStatus.UNCONDITIONAL], $setup.selectedStageId.value), (lot) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: lot._id
                          }, [
                            _createElementVNode("td", _hoisted_99, _toDisplayString(lot.title), 1),
                            _createElementVNode("td", _hoisted_100, _toDisplayString(lot.price && ["fixed", "from"].includes(lot.price.type?.toLowerCase()) && lot.price.value ? $setup.formatPrice(lot.price.value) : "--"), 1),
                            _createElementVNode("td", _hoisted_101, _toDisplayString($setup.getLotBuyers(lot.firstBuyer, lot.secondBuyer)), 1),
                            _createElementVNode("td", _hoisted_102, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["badge status-badge", lot.status === $setup.LotStatus.UNCONDITIONAL ? 'badge-unconditional' : 'badge-under-contract'])
                              }, _toDisplayString(lot.status), 3)
                            ]),
                            _createElementVNode("td", _hoisted_103, _toDisplayString($setup.formatDate(lot.exchangedDate)), 1),
                            _createElementVNode("td", _hoisted_104, _toDisplayString(lot.deposit ? $setup.formatPrice(lot.deposit) : "--"), 1),
                            _createElementVNode("td", _hoisted_105, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["badge", $setup.getConditionBadgeClass(lot.conditions)])
                              }, _toDisplayString(lot.conditions ? lot.conditions : "No Conditions"), 3)
                            ]),
                            _createElementVNode("td", _hoisted_106, _toDisplayString($setup.formatDate(lot.financeDueDate)), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_107, [
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("div", _hoisted_109, [
            _createVNode($setup["BarChart3"], {
              class: "activity-icon",
              color: "#2563eb"
            }),
            _cache[37] || (_cache[37] = _createElementVNode("span", null, "Recent Sales Activity", -1))
          ]),
          _createElementVNode("div", _hoisted_110, [
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                _createElementVNode("button", _hoisted_111, _toDisplayString($setup.selectedPeriod.label), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.periods, (period) => {
                    return _createElementVNode("li", {
                      onClick: ($event: any) => ($setup.changeFilter(period)),
                      class: _normalizeClass({ 'dropdown__item-active': $setup.selectedPeriod.value === period.value })
                    }, _toDisplayString(period.label), 11, _hoisted_112)
                  }), 64))
                ])
              ]),
              _: 1
            }),
            ($setup.selectedPeriod.value === 'custom')
              ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                  _withDirectives(_createElementVNode("input", {
                    class: "date-input",
                    type: "date",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.customDateFrom) = $event)),
                    placeholder: "From"
                  }, null, 512), [
                    [_vModelText, $setup.customDateFrom]
                  ]),
                  _cache[38] || (_cache[38] = _createElementVNode("span", { class: "date-separator" }, "to", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "date-input",
                    type: "date",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.customDateTo) = $event)),
                    placeholder: "To"
                  }, null, 512), [
                    [_vModelText, $setup.customDateTo]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_114, [
          _cache[39] || (_cache[39] = _createTextVNode("Status changes and activity during the selected timeframe", -1)),
          ($setup.selectedStageId.value !== 'all')
            ? (_openBlock(), _createElementBlock("span", _hoisted_115, _toDisplayString(" for " + $setup.selectedStageId.label), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_116, [
          _createElementVNode("div", _hoisted_117, [
            _createElementVNode("div", _hoisted_118, [
              _cache[40] || (_cache[40] = _createElementVNode("h4", { class: "activity-item-title" }, "Put on Hold", -1)),
              _createVNode($setup["Clock"], {
                class: "activity-item-icon",
                color: "#1d4ed8"
              })
            ]),
            _createElementVNode("div", _hoisted_119, [
              _createElementVNode("div", _hoisted_120, _toDisplayString($setup.recentSalesActivity.counts.putOnHold), 1),
              _cache[41] || (_cache[41] = _createElementVNode("div", { class: "activity-label" }, "Lots placed on hold", -1)),
              ($setup.recentSalesActivity.notes.putOnHold)
                ? (_openBlock(), _createElementBlock("div", _hoisted_121, _toDisplayString($setup.recentSalesActivity.notes.putOnHold), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("div", _hoisted_123, [
              _cache[42] || (_cache[42] = _createElementVNode("h4", { class: "activity-item-title" }, "Contracts Signed", -1)),
              _createVNode($setup["FileText"], {
                class: "activity-item-icon",
                color: "#1d4ed8"
              })
            ]),
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("div", _hoisted_125, _toDisplayString($setup.recentSalesActivity.counts.contractsSigned), 1),
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "activity-label" }, "New Contracts", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_126, [
            _cache[44] || (_cache[44] = _createElementVNode("div", { class: "activity-item-header" }, [
              _createElementVNode("h4", { class: "activity-item-title" }, "Cancellations"),
              _createElementVNode("div", { class: "activity-item-icon-circle" })
            ], -1)),
            _createElementVNode("div", _hoisted_127, [
              _createElementVNode("div", _hoisted_128, _toDisplayString($setup.recentSalesActivity.counts.cancellations), 1),
              _createElementVNode("div", _hoisted_129, "Contract" + _toDisplayString($setup.recentSalesActivity.counts.cancellations !== 1 ? "s" : "") + " Terminated", 1),
              ($setup.recentSalesActivity.counts.cancellations > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_130, "Returned to Available"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_131, [
            _createElementVNode("div", _hoisted_132, [
              _cache[45] || (_cache[45] = _createElementVNode("h4", { class: "activity-item-title" }, "Unconditional", -1)),
              _createVNode($setup["CheckCircle"], {
                class: "activity-item-icon",
                color: "#8b5cf6"
              })
            ]),
            _createElementVNode("div", _hoisted_133, [
              _createElementVNode("div", _hoisted_134, _toDisplayString($setup.recentSalesActivity.counts.unconditional), 1),
              _cache[46] || (_cache[46] = _createElementVNode("div", { class: "activity-label" }, "Went Unconditional", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_135, [
            _createElementVNode("div", _hoisted_136, [
              _cache[47] || (_cache[47] = _createElementVNode("h4", { class: "activity-item-title" }, "Settlements", -1)),
              _createVNode($setup["CheckCircle"], {
                class: "activity-item-icon",
                color: "#ec4899"
              })
            ]),
            _createElementVNode("div", _hoisted_137, [
              _createElementVNode("div", _hoisted_138, _toDisplayString($setup.recentSalesActivity.counts.settlements), 1),
              _cache[48] || (_cache[48] = _createElementVNode("div", { class: "activity-label" }, "Lots Settled", -1)),
              ($setup.recentSalesActivity.notes.settlements)
                ? (_openBlock(), _createElementBlock("div", _hoisted_139, _toDisplayString($setup.recentSalesActivity.notes.settlements), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_140, [
          _cache[51] || (_cache[51] = _createElementVNode("h4", { class: "breakdown-title" }, "Activity Breakdown by Status", -1)),
          ($setup.hasAnyActivity)
            ? (_openBlock(), _createElementBlock("div", _hoisted_141, [
                ($setup.recentSalesActivity.details.putOnHold.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                      _createElementVNode("div", _hoisted_143, [
                        _createVNode($setup["Clock"], {
                          class: "breakdown-icon",
                          color: "#0ea5e9"
                        }),
                        _createElementVNode("span", null, "Put on Hold (" + _toDisplayString($setup.recentSalesActivity.details.putOnHold.length) + ")", 1)
                      ]),
                      _createElementVNode("div", _hoisted_144, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recentSalesActivity.details.putOnHold, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["breakdown-item", { 'still-hold': item.badge === 'Still on hold', cancelled: item.badge === 'Cancelled', progressed: item.badge?.includes('Progressed') }]),
                            key: `hold-${item.lotId}-${item.date.getTime()}`
                          }, [
                            _createElementVNode("div", _hoisted_145, [
                              _createElementVNode("div", _hoisted_146, "Lot " + _toDisplayString(item.lotTitle), 1),
                              _createElementVNode("div", _hoisted_147, _toDisplayString($setup.formatRelativeDate(item.date)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_148, [
                              _createElementVNode("div", _hoisted_149, _toDisplayString($setup.formatPrice(item.price)), 1),
                              _createElementVNode("div", _hoisted_150, _toDisplayString(item.buyer), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass(["badge", item.badgeClass])
                              }, _toDisplayString(item.badge), 3)
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.allContractsActivity.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                      _createElementVNode("div", _hoisted_152, [
                        _createVNode($setup["FileText"], {
                          class: "breakdown-icon",
                          color: "#1d4ed8"
                        }),
                        _createElementVNode("span", null, "Contracts Signed (" + _toDisplayString($setup.allContractsActivity.length) + ")", 1)
                      ]),
                      _createElementVNode("div", _hoisted_153, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allContractsActivity, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["breakdown-item", { 'cancelled-contract': item.isTerminated, 'still-contract': !item.isTerminated && item.badge === 'Still Under Contract', progressed: !item.isTerminated && (item.badge?.includes('Progressed') || item.badge?.includes('Moved')) }]),
                            key: `contract-${item.lotId}-${item.date.getTime()}-${item.isTerminated}`
                          }, [
                            _createElementVNode("div", _hoisted_154, [
                              _createElementVNode("div", _hoisted_155, "Lot " + _toDisplayString(item.lotTitle), 1),
                              _createElementVNode("div", _hoisted_156, _toDisplayString($setup.formatRelativeDate(item.date)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_157, [
                              _createElementVNode("div", _hoisted_158, _toDisplayString($setup.formatPrice(item.price)), 1),
                              _createElementVNode("div", _hoisted_159, _toDisplayString(item.buyer), 1),
                              (item.badge)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["badge", item.badgeClass])
                                  }, _toDisplayString(item.badge), 3))
                                : _createCommentVNode("", true)
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.recentSalesActivity.details.wentUnconditional.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                      _createElementVNode("div", _hoisted_161, [
                        _createVNode($setup["CheckCircle"], {
                          class: "breakdown-icon",
                          color: "#8b5cf6"
                        }),
                        _createElementVNode("span", null, "Unconditional Contracts (" + _toDisplayString($setup.recentSalesActivity.details.wentUnconditional.length) + ")", 1)
                      ]),
                      _createElementVNode("div", _hoisted_162, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recentSalesActivity.details.wentUnconditional, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["breakdown-item", { 'still-unconditional': item.badge === 'Still Unconditional', cancelled: item.badge === 'Contract terminated', 'progressed-settled': item.badge?.includes('Progressed to Settled'), 'moved-contract': item.badge?.includes('Moved to Under Contract') }]),
                            key: `unconditional-${item.lotId}-${item.date.getTime()}`
                          }, [
                            _createElementVNode("div", _hoisted_163, [
                              _createElementVNode("div", _hoisted_164, "Lot " + _toDisplayString(item.lotTitle), 1),
                              _createElementVNode("div", _hoisted_165, _toDisplayString($setup.formatRelativeDate(item.date)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_166, [
                              _createElementVNode("div", _hoisted_167, _toDisplayString($setup.formatPrice(item.price)), 1),
                              _createElementVNode("div", _hoisted_168, _toDisplayString(item.buyer), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass(["badge", item.badgeClass])
                              }, _toDisplayString(item.badge), 3)
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.recentSalesActivity.details.settlements.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                      _createElementVNode("div", _hoisted_170, [
                        _createVNode($setup["CheckCircle"], {
                          class: "breakdown-icon",
                          color: "#ec4899"
                        }),
                        _createElementVNode("span", null, "Settlements (" + _toDisplayString($setup.recentSalesActivity.details.settlements.length) + ")", 1)
                      ]),
                      _createElementVNode("div", _hoisted_171, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recentSalesActivity.details.settlements, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "breakdown-item",
                            key: `settlement-${item.lotId}-${item.date.getTime()}`
                          }, [
                            _createElementVNode("div", _hoisted_172, [
                              _createElementVNode("div", _hoisted_173, "Lot " + _toDisplayString(item.lotTitle), 1),
                              _createElementVNode("div", _hoisted_174, _toDisplayString($setup.formatRelativeDate(item.date)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_175, [
                              _createElementVNode("div", _hoisted_176, _toDisplayString($setup.formatPrice(item.price)), 1),
                              _createElementVNode("div", _hoisted_177, _toDisplayString(item.buyer), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (!$setup.hasAnyActivity)
            ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                _createElementVNode("div", _hoisted_179, [
                  _createElementVNode("div", _hoisted_180, [
                    _createVNode($setup["BarChart3"], {
                      color: "#94a3b8",
                      size: 48
                    })
                  ]),
                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "placeholder-text" }, "No activity recorded for this period", -1)),
                  _cache[50] || (_cache[50] = _createElementVNode("div", { class: "placeholder-hint" }, "Try selecting a different time range to view activity", -1))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_181))
      : _createCommentVNode("", true),
    _createVNode($setup["ExportPDFModal"], {
      isOpen: $setup.showExportModal,
      stages: $setup.stages,
      onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.showExportModal = false)),
      onGenerate: $setup.handleGeneratePDF
    }, null, 8, ["isOpen", "stages"])
  ]))
}